import React from 'react';

const PrivacyPolicyText = () => (
  <div className="GenericText__content">
    <h2>Privacy Policy</h2>

    <p>
      <em>Updated: May 20, 2018</em>
    </p>

    <p>
      Welcome to Funbrain. We provide educational games, videos, and books for
      kids. We at Funbrain Holdings LLC (“Funbrain”) operate this website
      ("Website") and is are committed to protecting the privacy and security of
      its online visitors—especially the privacy of children who visit this
      site. Funbrain is a wholly owned subsidiary of Tinybop Inc.
    </p>

    <p>
      We are sensitive to family and educator concerns about children's safety
      and information related to them. We want you to know about and understand
      the measures we have taken to keep the websites and online services
      provided by Funbrain a safe and secure environment for everyone. We would
      like every visitor to know that we do not knowingly collect any personally
      identifiable information from children.
    </p>

    <p>
      We encourage our visitors to read through and understand our privacy
      statement. We may update it from time to time to address new issues or
      reflect changes on our Website. Please refer to this privacy statement
      regularly. Funbrain reserves the right to revise this privacy statement at
      any time and such revisions shall be effective immediately upon notice
      thereof. Notice may be given by any means including, but not limited to,
      posting the revised privacy statement on this Website. Any use of our site
      by you subsequent to such notice shall be deemed to constitute acceptance
      by you of such revision.
    </p>

    <p>
      If you have any questions or concerns about this privacy statement, or
      your dealings with Funbrain, please:
    </p>

    <ol>
      <li>
        <a href="mailto:help@funbrain.com">Contact us</a>
      </li>
      <li>
        Write to us at: Funbrain Holdings LLC, 540 Atlantic Avenue, 5th Floor,
        Brooklyn, NY 11217
      </li>
      <li>Call: 516-500-1967</li>
    </ol>

    <h3>HELPFUL EXPLANATIONS</h3>

    <p>
      An <strong>IP address</strong> is a number that is assigned automatically
      to your computer whenever you use the World Wide Web. Web servers -- the
      big computers that "serve up" Web pages -- automatically identify your
      computer by its IP address.
    </p>
    <p>
      <strong>Cookies</strong> are small pieces of data stored on your device as
      a text file (computer or mobile device).
    </p>
    <p>
      <strong>Personal information</strong> means information that would
      identify you, directly or indirectly, such as your name, mailing address,
      email address or telephone number.{' '}
    </p>
    <p>
      <strong>Anonymized information</strong> means information that does not or
      could not reasonably be used to identify a specific individual.{' '}
    </p>
    <p>
      <strong>Data Controller</strong> means the natural or legal person who
      (either alone or jointly or in common with other persons) determines the
      purposes for which and the manner in which any personal information and
      anonymized information are, or are to be, processed.
    </p>
    <p>
      For the purpose of this Privacy Policy, we are a Data Controller of your
      Personal Data.
    </p>
    <p>
      <strong>Data Processor</strong> (or Service Provider) means any natural or
      legal person who processes the data on behalf of the Data Controller.
    </p>
    <p>
      We may use the services of various Service Providers in order to process
      your data more effectively.
    </p>

    <h3>INFORMATION WE COLLECT FROM YOU</h3>

    <p>
      We do not knowingly collect personal information from our visitors though
      visitors might provide us personal information by reaching out for support
      or joining our mailing list.{' '}
    </p>

    <p>
      We do collect anonymized information regarding site activity from users.
    </p>

    <p>
      This Website may contain games where free form text entry is permitted,
      but this content is only visible to the person playing the game. We do not
      host games that allow children to post or share personal information
      publicly.
    </p>

    <p>
      We collect anonymized information from your computer or device such as
      browser type, operating system, referring pages, pages visited, time spent
      on a particular page and IP address. IP addresses are automatically
      anonymized.
    </p>

    <h3>HOW WE COLLECT YOUR INFORMATION</h3>

    <p>
      When you use this website, we collect personal information and anonymized
      information through a variety of methods.
    </p>

    <p>
      We collect personal information from you when you interact with this
      Website by reaching out to submit a customer service requests or sign up
      for our mailing list.
    </p>

    <p>
      We collect anonymized information from you by using technologies like
      cookies, web beacons and server logs.
    </p>

    <p>
      This Website contains cookies from Funbrain and third parties. While
      browsing through this Website, you may get cookies from our advertisers or
      sponsors. Funbrain does not control these cookies.
    </p>

    <p>
      We may also use single pixels images, web beacons and other similar
      technology (collectively "Beacons") to (a) track your usage of the
      Website, (b) track response rates to certain activities and promotions
      within the Website and in marketing campaigns, and (c) identify certain
      information on how and when you accessed the Website such as type of
      browser, operating system, domain names, IP addresses and the like.
    </p>

    <h3>HOW WE USE YOUR INFORMATION</h3>

    <p>
      Funbrain may use your personal information to tailor the content
      programming, services, and applications that we provide to meet your needs
      and interests.
    </p>

    <p>
      When visitors request pages from Funbrain sites, our servers log users’ IP
      addresses. IP addresses are automatically anonymized. Visitor’s session
      will be logged, but the visitor remains anonymous to us.
    </p>

    <p>
      Funbrain collects IP addresses for system administration, to report
      aggregate information to our advertisers, sponsors, and partners, and to
      audit the use of our site. We will use IP addresses to identify a user in
      the following situations: (a) in response to subpoenas, court orders or
      legal process, to the extent permitted and as restricted by law; (b) when
      disclosure is required to maintain the security and integrity of this
      site, or to protect any user's security or the security of other persons,
      consistent with applicable laws.
    </p>

    <p>
      The anonymized information we track with cookies is not used to identify,
      or lead us back to, any particular individual. Visitors to this Website
      may have the option of disabling cookies via their browser preferences
      (most browsers are initially set up to accept cookies). Cookies make our
      Website easier for you to use because they save your preferences while you
      are visiting our sites (although we do not save passwords in cookies).
    </p>

    <p>
      Funbrain may also use third party vendors who supply applications, web
      hosting and other technologies for this Website that may have access to
      your personal information and anonymized information but by mutual
      agreement will never use such information for any other purpose except to
      provide services in connection with this site.
    </p>

    <p>
      Funbrain will not share any personal information about you with any third
      party, except as otherwise stated in this Privacy Statement and in the
      following circumstances: (a) in response to subpoenas, court orders or
      legal process, to the extent permitted and as restricted by law; (b) when
      disclosure is required to maintain the security and integrity of this
      site, or to protect any user's security or the security of other persons,
      consistent with applicable laws; (c) when disclosure is directed or
      consented to by the registered member who has inputted the personal
      information; (d) in the event that Funbrain Holdings LLC or any of its
      subdivisions or units goes through a business transition, such as a
      merger, divestiture, acquisition, liquidation or sale of all or a portion
      of its assets, your personal information will, in most instances, be part
      of the assets transferred; or (e) in limited circumstances, Funbrain may
      disclose your email address in order to comply with laws and regulations,
      including the Controlling the Assault of Non-Solicited Pornography and
      Marketing Act (CAN-SPAM of 2003).
    </p>

    <h3>DO NOT TRACK</h3>

    <p>
      This Website does not respond to your browser's (or app's) "do-not-track"
      signals or comparable signals or mechanisms. Please check our Privacy
      Statement frequently as this may change in the future.
    </p>

    <h3 id="childrens-privacy">CHILDREN'S PRIVACY</h3>

    <p>
      Funbrain encourages parents and guardians to supervise their child's use
      of the Internet. We urge parents to instruct their children to never give
      out their real names, addresses, phone numbers, or other personal
      information without a parent's or guardian's permission when using the
      Internet. We recognize a special obligation to protect personal
      information obtained from children and by design do not collect this
      information. For this reason, Funbrain does not request, collect, or store
      any personal information knowingly from children under 18. Some games
      might ask children for their names, but this information is never shown to
      us and is only seen locally on the child’s machine.
    </p>

    <p>
      As a parent, you've probably done a lot of thinking about protecting your
      family's privacy on the Internet. We have been thinking and working hard
      to provide you with the best information and the highest quality
      interaction on the Internet in an environment that is safe. In compliance
      with COPPA (the Children's Online Privacy Protection Act), we have adopted
      the following policies to keep kids safe (there are exceptions to these
      policies as noted below under the heading “Exceptions to Verifiable
      Parental Consent and Information Collected from Children”):
    </p>

    <ul>
      <li>
        We will NOT knowingly collect, use, or distribute personal information
        from children under the age of 18 without prior verifiable consent from
        a parent or guardian.
      </li>
      <li>
        We will NOT knowingly ask a child under the age of 18 to divulge more
        information than is needed to participate in any activity, game, or
        service.
      </li>
      <li>
        We will NOT knowingly keep any personal information that is
        inadvertently included in a child's email submission, help inquiry, or
        other one-time request, if we know that the child is under the age of
        18. Any such information will be purged promptly after the issue has
        been resolved.
      </li>
      <li>
        We will NOT knowingly post any personal information that is
        inadvertently included in a child's submission to a general audience
        contribution area if we know that the child is under the age of 18. Upon
        notice to us, these submissions will be deleted and handled anonymously
        thereafter.
      </li>
      <li>
        We will NOT knowingly provide any direct link to websites that are
        unsuitable for children or teens.
      </li>
      <li>
        Upon request, Funbrain will provide a parent or guardian with a
        description of the information that may have been provided about their
        child during a registration process for a program or service of this
        site. Funbrain only asks for a child's or teen's personal information if
        it is necessary to participate in an activity, game or service. If we
        have collected and stored personal information from a child, we will
        give parents the ability to review their child's personal information,
        request that we discontinue further collection or use of their child's
        personal information, and/or request that we delete their child's
        personal information.
      </li>
    </ul>

    <p>
      If you have any questions about this Privacy Statement, please contact
      Funbrain at <a href="mailto:help@funbrain.com">help@funbrain.com</a> or
      516-500-1967
    </p>

    <h3>NOTIFICATION AND VERIFIABLE PARENTAL CONSENT</h3>

    <p>
      Before any personal information is collected from a child, we will do our
      best to notify the parent or guardian that their child is participating.
      Notification will include the exact nature and intended use of the
      information we are collecting, as well as the opportunity for the parent
      or guardian to prevent the use of the information and the child's
      participation in the activity. For every child (anyone under 18 years of
      age), we will also require the parent or guardian to provide verifiable
      parental consent such as: by email plus a fax, phone or letter follow up
      by the parent or guardian; mail, fax or scan of a consent form; or
      toll-free phone call to Funbrain; or other acceptable method.
    </p>

    <p>
      In order for us to provide notice to a parent or guardian and seek
      verifiable parental consent, we may request the online contact information
      of a parent or guardian. This contact information will only be used for
      the sole purpose of obtaining verifiable parental consent or providing
      notification to the parent or guardian.
    </p>

    <h3>ABOUT OUR ADVERTISERS</h3>

    <p>
      This Website includes advertising by third parties. Funbrain does not
      control the linking practices of advertisers or sponsors and does not
      monitor or claim responsibility for any content or privacy practices of
      such websites. Once you have clicked on an advertisement and have left
      this Website, you must read the privacy policy of the advertiser or
      sponsor to see how your personal information will be handled.
    </p>

    <p>
      Funbrain may offer contests, sweepstakes, and promotions that are
      sponsored by third-party advertisers or sponsors. These third parties may
      obtain personal information that visitors voluntarily submit to
      participate in the activity. Funbrain does not control the third parties’
      use of information.
    </p>

    <p>
      Funbrain may use advertising servers developed by third parties to display
      ads on this Website. Some of these ads may contain cookies that are set by
      third parties (advertisers, sponsors) and may use anonymized information
      (not including your name, address, email address, telephone number) about
      your visits to this and other sites in order to provide advertisements
      about goods and services of interest to you. We do not have access to
      these cookies or any information that they transmit. The Funbrain privacy
      statement does not cover any use of information that a third-party ad
      server may have collected from you. Please note that Funbrain does not
      engage in the practice of showing or tracking users for interest-based
      advertisements on its child-directed sites. Funbrain’s advertisers have
      all agreed to only show ads appropriate for children.
    </p>

    <p>
      For more information on ad serving, please go to{' '}
      <a href="http://www.allaboutcookies.org/ad-serving/">
        allaboutcookies.org/ad-serving/
      </a>
      . If you would like to know your choices about not having information used
      by these third parties, please go to{' '}
      <a href=">http://www.networkadvertising.org/understanding-online-advertising/what-are-my-options">
        networkadvertising.org/understanding-online-advertising/what-are-my-options
      </a>
    </p>

    <h3>A NOTICE ABOUT EXTERNAL LINKS</h3>

    <p>
      Occasionally, you will find links from Funbrain to independently owned,
      controlled, and/or managed Websites whose content we believe will be of
      possible interest and value to our visitors. Additionally, you'll see
      links from advertisers, sponsors, and other partners who may use a
      Funbrain owned logo as part of a co-branding agreement.
    </p>

    <p>
      In many cases, these links represent cooperative projects or mutual links
      established with the organizations connected with these sites. We do not
      control the content of these links.
    </p>

    <p>
      Funbrain has partnered with other companies to provide certain services.
      In some cases, you may see a Funbrain logo on another company's site.
      Funbrain does not share any of your personal information with these
      partners and they do not share any information with us.
    </p>

    <p>
      We specifically recommend that children check with their parents,
      guardians, or teachers before connecting to any third party sites.
    </p>

    <h3>
      Legal Basis for Processing Personal Data Under General Data Protection
      Regulation (GDPR)
    </h3>

    <p>
      If you are from the European Economic Area (EEA), Funbrain legal basis for
      collecting and using the personal information described in this Privacy
      Policy depends on the Personal Data we collect and the specific context in
      which we collect it.
    </p>

    <p>Funbrain may process your Personal Data because:</p>

    <ul>
      <li>We need to perform a contract with you</li>
      <li>You have given us permission to do so</li>
      <li>
        The processing is in our legitimate interests and it's not overridden by
        your rights
      </li>
      <li>To comply with the law</li>
    </ul>

    <h4>Retention of Data</h4>

    <p>
      Funbrain will retain your Personal Data only for as long as is necessary
      for the purposes set out in this Privacy Policy. We will retain and use
      your Personal Data to the extent necessary to comply with our legal
      obligations (for example, if we are required to retain your data to comply
      with applicable laws), resolve disputes, and enforce our legal agreements
      and policies.
    </p>

    <p>
      Funbrain will also retain Usage Data for internal analysis purposes. Usage
      Data is generally retained for a shorter period of time, except when this
      data is used to strengthen the security or to improve the functionality of
      our Service, or we are legally obligated to retain this data for longer
      time periods.
    </p>

    <h4>Transfer Of Data</h4>

    <p>
      Your information, including Personal Data, may be transferred to — and
      maintained on — computers located outside of your state, province, country
      or other governmental jurisdiction where the data protection laws may
      differ than those from your jurisdiction.
    </p>

    <p>
      If you are located outside United States and choose to provide information
      to us, please note that we transfer the data, including Personal Data, to
      United States and process it there.
    </p>

    <p>
      Your consent to this Privacy Policy followed by your submission of such
      information represents your agreement to that transfer.
    </p>

    <p>
      Funbrain will take all steps reasonably necessary to ensure that your data
      is treated securely and in accordance with this Privacy Policy and no
      transfer of your Personal Data will take place to an organization or a
      country unless there are adequate controls in place including the security
      of your data and other personal information.
    </p>

    <h4>Disclosure Of Data</h4>

    <p>
      <strong>Disclosure for Law Enforcement</strong>
    </p>

    <p>
      Under certain circumstances, Funbrain may be required to disclose your
      Personal Data if required to do so by law or in response to valid requests
      by public authorities (e.g. a court or a government agency).
    </p>

    <p>
      <strong>Legal Requirements</strong>
    </p>

    <p>
      Funbrain may disclose your Personal Data in the good faith belief that
      such action is necessary to:
    </p>
    <ul>
      <li>To comply with a legal obligation</li>
      <li>To protect and defend the rights or property of Funbrain</li>
      <li>
        To prevent or investigate possible wrongdoing in connection with the
        Service
      </li>
      <li>
        To protect the personal safety of users of the Service or the public
      </li>
      <li>To protect against legal liability</li>
    </ul>

    <p>
      <strong>Security Of Data</strong>
    </p>

    <p>
      The security of your data is important to us, but remember that no method
      of transmission over the Internet, or method of electronic storage is 100%
      secure. While we strive to use commercially acceptable means to protect
      your Personal Data, we cannot guarantee its absolute security.
    </p>

    <h4>“Do Not Track” Signals</h4>

    <p>
      We do not support Do Not Track (“DNT”). Do Not Track is a preference you
      can set in your web browser to inform websites that you do not want to be
      tracked.
    </p>

    <p>
      You can enable or disable Do Not Track by visiting the Preferences or
      Settings page of your web browser.
    </p>

    <h3>
      Your Data Protection Rights Under General Data Protection Regulation
      (GDPR)
    </h3>

    <p>
      If you are a resident of the European Economic Area (EEA), you have
      certain data protection rights. Funbrain aims to take reasonable steps to
      allow you to correct, amend, delete, or limit the use of your Personal
      Data. If you wish to be informed what Personal Data we hold about you and
      if you want it to be removed from our systems, please contact us.
    </p>

    <p>
      In certain circumstances, you have the following data protection rights:
    </p>

    <p>
      The right to access, update or to delete the information we have on
      you.Whenever made possible, you can access, update or request deletion of
      your Personal Data directly within your account settings section. If you
      are unable to perform these actions yourself, please contact us to assist
      you.
    </p>

    <p>
      The right of rectification. You have the right to have your information
      rectified if that information is inaccurate or incomplete.
    </p>

    <p>
      The right to object. You have the right to object to our processing of
      your Personal Data.
    </p>

    <p>
      The right of restriction. You have the right to request that we restrict
      the processing of your personal information.
    </p>

    <p>
      The right to data portability.You have the right to be provided with a
      copy of the information we have on you in a structured, machine-readable
      and commonly used format.
    </p>

    <p>
      The right to withdraw consent. You also have the right to withdraw your
      consent at any time where Funbrain relied on your consent to process your
      personal information.
    </p>

    <p>
      Please note that we may ask you to verify your identity before responding
      to such requests.
    </p>

    <p>
      You have the right to complain to a Data Protection Authority about our
      collection and use of your Personal Data. For more information, please
      contact your local data protection authority in the European Economic Area
      (EEA).
    </p>

    <h4>Service Providers</h4>

    <p>
      We may employ third party companies and individuals to facilitate our
      Service ("Service Providers"), to provide the Service on our behalf, to
      perform Service-related services or to assist us in analyzing how our
      Service is used.
    </p>

    <p>
      These third parties have access to your Personal Data only to perform
      these tasks on our behalf and are obligated not to disclose or use it for
      any other purpose.
    </p>

    <h4>Analytics and External Services</h4>

    <p>
      We may use third-party Service Providers to monitor and analyze the use of
      our Service.
    </p>

    <p>
      <strong>Google Analytics</strong>
      <br />
      Google Analytics is a web analytics service offered by Google that tracks
      and reports website traffic. Google uses the data collected to track and
      monitor the use of our Service. This data is shared with other Google
      services. Google may use the collected data to contextualize and
      personalize the ads of its own advertising network.
    </p>

    <p>
      For more information on the privacy practices of Google, please visit the
      Google Privacy Terms web page:{' '}
      <a href="http://www.google.com/intl/en/policies/privacy/">
        http://www.google.com/intl/en/policies/privacy/
      </a>
    </p>

    <h3>Changes To This Privacy Policy</h3>

    <p>
      We may update our Privacy Policy from time to time. We will notify you of
      any changes by posting the new Privacy Policy on this page.
    </p>

    <p>
      We will let you know via email and/or a prominent notice on our Service,
      prior to the change becoming effective and update the "effective date" at
      the top of this Privacy Policy.
    </p>

    <p>
      You are advised to review this Privacy Policy periodically for any
      changes. Changes to this Privacy Policy are effective when they are posted
      on this page.
    </p>

    <h3>CONTACT US</h3>
    <p>
      If you have any questions about this privacy statement, please contact us:
    </p>

    <ol>
      <li>
        <a href="mailto:help@funbrain.com">help@funbrain.com</a>
      </li>
      <li>
        Write to us at: Funbrain Holdings LLC, 540 Atlantic Avenue, 5th Floor,
        Brooklyn, NY 11217
      </li>
      <li>Call: 516-500-1967</li>
    </ol>
  </div>
);

export default PrivacyPolicyText;
